import { render, staticRenderFns } from "./VBtnAlterar.vue?vue&type=template&id=c0f4b588&"
import script from "./VBtnAlterar.vue?vue&type=script&lang=js&"
export * from "./VBtnAlterar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports